
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    accountUrl: {
      type: String,
      default: '/',
    },
  },
}
